import api from "./api";

class PedidoAPI {

    async getAmostra(headers) {
        const response = await api.get("/get_amostra", {headers});
        return response;
    }

    async getRentabilidadeFornecedores(headers, params) {
        const response = await api.get("/get_rentabilidade_fornecedores", {params, headers});
        return response;
    }

    async getRentabilidadeFornecedorItens(headers, params) {
        const response = await api.get("/get_rentabilidade_fornecedor_itens", {params, headers});
        return response;
    }
    
    async gerarDadosRentabilidade(headers, params) {
        const response = await api({
            method: 'post',
            url: '/gerar_dados_rentabilidade',
            headers,
            data: params
        });
        return response;
    }

}

export default new PedidoAPI();